import React from "react";
import styles from './More.module.css';

const More = () => {

  return (
    <div className={styles.moreCont}>
      <p className={styles.moreText}>Coming soon... Stay tuned!</p>
    </div>
  )
}

export default More;